import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import axios from "axios"
Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
 return originalPush.call(this, location).catch(err => err)
}
let router =  new Router({
	mode: 'history',
	routes: [{
			path: '/',
			name: '/',
			component: resolve => require(['@/view/index'], resolve),
		},
		{
			path: '/pList',
			name: 'Plist',
			component: resolve => require(['@/view/pList'], resolve),
		},
		{
			path: '/pDetail',
			name: 'PDetail',
			component: resolve => require(['@/view/pDetail'], resolve),
		},
		{
			path: '/play',
			name: 'play',
			component: resolve => require(['@/view/play'], resolve),
		},
		{
			path: '/dynamic',
			name: 'dynamic',
			component: resolve => require(['@/view/dynamic'], resolve),
		},
		{
			path: '/zhengce',
			name: 'zhengce',
			component: resolve => require(['@/view/zhengce'], resolve),
		},
		{
			path: '/dynamic_detail',
			name: 'dynamic_detail',
			component: resolve => require(['@/view/dynamicDetail'], resolve),
		},
		{
			path: '/test_notice',
			name: 'test_notice',
			component: resolve => require(['@/view/testNotice'], resolve),
		},
		{
			path: '/contact',
			name: 'contact',
			component: resolve => require(['@/view/contact'], resolve),
		},
		{
			path: '/about',
			name: 'about',
			component: resolve => require(['@/view/about'], resolve),
		},
		{
			path: '/pay',
			name: 'pay',
			component: resolve => require(['@/view/pay'], resolve),
		},
		{
			path: '/school',
			name: 'school',
			component: resolve => require(['@/view/school'], resolve),
		},
		{
			path: '/specially',
			name: 'specially',
			component: resolve => require(['@/view/specially'], resolve),
		},
		{
			path:"*",
			redirect:'/'
		}
	],
	
	 scrollBehavior (to, from, savedPosition) {
	 if (savedPosition) {
	  return savedPosition
	 } else {
	  return { x: 0, y: 0 }
	 }
	 }
})



export default router

router.beforeEach((to, from, next) => {
	let token = localStorage.getItem('token')
	if(token){
		axios.get('/account/status/').then(res =>{
			if(res.data.code==20000){
				next()
			}else{
				localStorage.removeItem('token')
				next()
			}
		})
	}else{
		next()
	}
	
	
})


// WEBPACK FOOTER //
// ./src/router/index.js